module.exports = __webpack_public_path__ + "img/pinlocation.76e14273.svg";